const API_BASE = '/api';

function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('sessionToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

export interface StockSearchResult {
  '1. symbol': string;
  '2. name': string;
  '3. type': string;
  '4. region': string;
  '5. marketOpen': string;
  '6. marketClose': string;
  '7. timezone': string;
  '8. currency': string;
  '9. matchScore': string;
}

export interface HistoricalDataPoint {
  date: string;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
}

export async function searchStocks(query: string): Promise<StockSearchResult[]> {
  const response = await fetch(`${API_BASE}/stocks/search?q=${encodeURIComponent(query)}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to search stocks');
  }

  return response.json();
}

export async function getStockPrice(symbol: string): Promise<{ symbol: string; price: number }> {
  const response = await fetch(`${API_BASE}/stocks/price/${symbol}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch stock price');
  }

  return response.json();
}

export async function getHistoricalData(symbol: string, period: string): Promise<HistoricalDataPoint[]> {
  const response = await fetch(`${API_BASE}/stocks/history/${symbol}?period=${period}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch historical data');
  }

  return response.json();
}

export async function convertCurrency(from: string, to: string, amount: number) {
  const response = await fetch(
    `${API_BASE}/stocks/convert?from=${from}&to=${to}&amount=${amount}`,
    {
      headers: getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to convert currency');
  }

  return response.json();
}
